(() => {
  'use strict';
  if (window.bcEditorial) return;
  window.bcEditorial = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const pointer = matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = () => motion.matches || document.documentElement.classList.contains('bc-review-reduced');
  const sections = new Map();
  const select = (root, selector) => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  function init(root = document) {
    select(root, '[data-bc-hero], [data-bc-scene], [data-bc-product], .bc-header').forEach(section => {
      if (sections.has(section)) return;
      const abort = new AbortController();
      const observers = [];
      const opts = { signal: abort.signal };
      let frame = 0;
      const on = (target, event, action) => target.addEventListener(event, action, opts);
      if (section.matches('[data-bc-hero]')) {
        const layers = section.querySelectorAll('[data-bc-depth]');
        let visible = true;
        const reset = () => { cancelAnimationFrame(frame); layers.forEach(el => { el.style.translate = ''; }); };
        const watch = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; if (!visible) reset(); });
        watch.observe(section); observers.push(watch);
        on(section, 'pointermove', event => {
          if (!visible || reduced() || !pointer.matches) return;
          const box = section.getBoundingClientRect();
          const x = ((event.clientX - box.left) / box.width - .5) * 16;
          const y = ((event.clientY - box.top) / box.height - .5) * 12;
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => layers.forEach(el => {
            const depth = Number(el.dataset.bcDepth);
            el.style.translate = `${x * depth}px ${y * depth}px`;
          }));
        });
        on(section, 'pointerleave', reset);
        on(motion, 'change', reset);
        on(pointer, 'change', reset);
      }
      if (section.matches('[data-bc-scene]')) {
        let played = false;
        const watch = new IntersectionObserver(entries => {
          const visible = entries[0].isIntersecting;
          section.style.animationPlayState = visible ? 'running' : 'paused';
          section.querySelectorAll('img, .bc-stem').forEach(el => { el.style.animationPlayState = visible ? 'running' : 'paused'; });
          if (visible && !played) { played = true; if (!reduced()) section.classList.add('bc-scene-enter'); }
        }, { threshold: .12 });
        watch.observe(section.querySelector('.bc-story-photo')); observers.push(watch);
      }
      if (section.matches('.bc-header')) {
        const update = () => section.classList.toggle('bc-scrolled', scrollY > 24);
        on(window, 'scroll', update); update();
      }
      if (section.matches('[data-bc-product]')) {
        const input = section.querySelector('input[name="quantity"]');
        if (input) {
          const syncQuantity = () => section.querySelectorAll('[data-quantity-step]').forEach(button => {
            const value = Number(input.value);
            button.disabled = input.disabled || (button.dataset.quantityStep === '-1' ? value <= Number(input.min || 1) : input.hasAttribute('max') && value >= Number(input.max));
          });
          on(input, 'input', syncQuantity); on(input, 'change', syncQuantity); syncQuantity();
        }
        const access = section.querySelector('[data-bc-mobile-access]');
        if (access) {
          let buyVisible = false, heroVisible = true, footerVisible = false;
          const refresh = () => {
            const banner = document.querySelector('#shopify-pc__banner, .shopify-pc__banner, #shopify-pc__prefs');
            const cookieVisible = banner && banner.getBoundingClientRect().height > 0 && getComputedStyle(banner).visibility !== 'hidden';
            access.hidden = buyVisible || heroVisible || footerVisible || !!cookieVisible;
          };
          const buy = section.querySelector('.bc-buy-copy');
          const hero = document.querySelector('.bc-hero-actions');
          const footer = document.querySelector('.bc-footer');
          const watch = new IntersectionObserver(entries => {
            entries.forEach(entry => { if (entry.target === buy) buyVisible = entry.isIntersecting; if (entry.target === hero) heroVisible = entry.isIntersecting; if (entry.target === footer) footerVisible = entry.isIntersecting; }); refresh();
          }, { threshold: 0 });
          [buy, hero, footer].filter(Boolean).forEach(el => watch.observe(el)); observers.push(watch);
          on(window, 'scroll', refresh); on(document, 'visitorConsentCollected', refresh);
          const cookies = new MutationObserver(records => {
            if (records.some(r => [...r.addedNodes, ...r.removedNodes].some(n => n.nodeType === 1 && (n.matches?.('[id^="shopify-pc"]') || n.querySelector?.('[id^="shopify-pc"]'))))) refresh();
          });
          cookies.observe(document.body, { childList: true, subtree: true }); observers.push(cookies);
          refresh();
        }
      }
      sections.set(section, () => { abort.abort(); cancelAnimationFrame(frame); observers.forEach(o => o.disconnect()); });
    });
  }
  // Reopen Shopify's native consent panel from the footer without changing consent.
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href*="shopifyReshowConsentBanner"]');
    if (link && window.Shopify?.privacyBanner?.showPreferences) {
      event.preventDefault();
      window.Shopify.privacyBanner.showPreferences();
    }
  });
  // Shopify injects this link with its consent mechanism. Change the label only.
  function translateConsent() {
    document.querySelectorAll('.bc-footer a').forEach(link => {
      if (link.href.includes('shopifyReshowConsentBanner')) link.textContent = 'Preferencias de cookies';
      else if (link.textContent.trim() === 'Privacy policy') link.textContent = 'Política de privacidad';
    });
  }
  function watchFooter() {
    footerObserver.disconnect();
    const footer = document.querySelector('.bc-footer');
    if (footer) footerObserver.observe(footer, { childList: true, subtree: true });
    translateConsent();
  }
  const footerObserver = new MutationObserver(() => {
    // Avoid an observer loop: only replace untranslated labels.
    document.querySelectorAll('.bc-footer a').forEach(link => {
      if (link.href.includes('shopifyReshowConsentBanner') && link.textContent !== 'Preferencias de cookies') link.textContent = 'Preferencias de cookies';
      if (link.textContent.trim() === 'Privacy policy') link.textContent = 'Política de privacidad';
    });
  });
  // Dawn publishes cartUpdate only after the Shopify add request succeeds.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.source !== 'product-form' || !event.cartData || event.cartData.status) return;
      document.querySelectorAll('[data-native-feedback]').forEach(el => { el.textContent = 'Añadido al carrito.'; });
      if (!reduced()) document.querySelectorAll('.bc-buy .product-form__submit').forEach(button => {
        button.classList.remove('bc-added'); requestAnimationFrame(() => button.classList.add('bc-added'));
      });
    });
    subscribe(PUB_SUB_EVENTS.cartError, () => document.querySelectorAll('[data-native-feedback]').forEach(el => { el.textContent = ''; }));
  }
  document.addEventListener('shopify:section:load', event => { init(event.target); watchFooter(); });
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, cleanup] of sections) if (event.target.contains(section)) { cleanup(); sections.delete(section); }
  });
  init(); watchFooter();
})();
